import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "newsletter_template": {
      "column": null,
      "name": "newsletter_template",
      "selected_by_default": null,
      "translated": null
    },
    "scheduled_at": {
      "column": {
        "default": null,
        "name": "scheduled_at",
        "null": true,
        "type": "datetime"
      },
      "name": "scheduled_at",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "new",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "time_zone_name": {
      "column": {
        "default": null,
        "name": "time_zone_name",
        "null": true,
        "type": "string"
      },
      "name": "time_zone_name",
      "selected_by_default": null,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "NewsletterTemplateTimeZoneState",
  "collectionKey": "newsletter_template_time_zone_states",
  "collectionName": "newsletter_template_time_zone_states",
  "i18nKey": "newsletter_template_time_zone_state",
  "camelizedLower": "newsletterTemplateTimeZoneState",
  "name": "NewsletterTemplateTimeZoneState",
  "nameDasherized": "newsletter-template-time-zone-state",
  "pluralName": "newsletter_template_time_zone_states",
  "ransackable_associations": [
    {
      "className": "NewsletterTemplateTimeZoneState::Audit",
      "collectionName": "newsletter_template_time_zone_state_audits",
      "foreignKey": "newsletter_template_time_zone_state_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "NewsletterTemplateTimeZoneStateAudit",
      "through": null
    },
    {
      "className": "NewsletterTemplateTimeZoneState::Audit",
      "collectionName": "newsletter_template_time_zone_state_audits",
      "foreignKey": "newsletter_template_time_zone_state_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "NewsletterTemplateTimeZoneStateAudit",
      "through": null
    },
    {
      "className": "NewsletterTemplate",
      "collectionName": "newsletter_templates",
      "foreignKey": "newsletter_template_id",
      "name": "newsletter_template",
      "macro": "belongs_to",
      "resource_name": "NewsletterTemplate",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "newsletter_template_id",
      "column": {
        "default": null,
        "name": "newsletter_template_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "scheduled_at",
      "column": {
        "default": null,
        "name": "scheduled_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "new",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "time_zone_name",
      "column": {
        "default": null,
        "name": "time_zone_name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "time_zone_offset",
      "column": {
        "default": null,
        "name": "time_zone_offset",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "NewsletterTemplate",
      "collectionName": "newsletter_templates",
      "foreignKey": "newsletter_template_id",
      "name": "newsletter_template",
      "macro": "belongs_to",
      "resource_name": "NewsletterTemplate",
      "through": null
    }
  ],
  "paramKey": "newsletter_template_time_zone_state",
  "primaryKey": "id"
}

/** Frontend model for NewsletterTemplateTimeZoneState. */
class NewsletterTemplateTimeZoneState extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  newsletterTemplate() {
    return this.readAttributeUnderscore("newsletter_template")
  }

  /** @returns {boolean} */
  hasNewsletterTemplate() {
    const value = this.newsletterTemplate()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  scheduledAt() {
    return this.readAttributeUnderscore("scheduled_at")
  }

  /** @returns {boolean} */
  hasScheduledAt() {
    const value = this.scheduledAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  timeZoneName() {
    return this.readAttributeUnderscore("time_zone_name")
  }

  /** @returns {boolean} */
  hasTimeZoneName() {
    const value = this.timeZoneName()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  send(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "send",
        primaryKey: this.primaryKey(),
        collectionName: "newsletter_template_time_zone_states",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./newsletter-template.js").default | null} */
  newsletterTemplate() {
    return this._readBelongsToReflection({reflectionName: "newsletter_template"})
  }

  /** @returns {Promise<import("./newsletter-template.js").default | null>} */
  loadNewsletterTemplate() {
    if (!("newsletterTemplateId" in this)) throw new Error("Foreign key method wasn't defined: newsletterTemplateId")

    const id = this.newsletterTemplateId()
    const modelClass = modelClassRequire("NewsletterTemplate")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "newsletter_template", model: this, modelClass},
      {ransack}
    )
  }
}

export default NewsletterTemplateTimeZoneState
